import Vue from "vue/dist/vue.esm.js";
import IndexList from "./pages/Index/IndexList.vue";
import StudioList from "./pages/StudioList/StudioList.vue";
import StudioDetail from "./pages/StudioDetail/StudioDetail.vue";
import RecommendList from "./pages/StudioDetail/Partials/RecommendList.vue";
import AreaList from "./pages/StudioDetail/Partials/AreaList.vue";

Vue.config.productionTip = false;

document.addEventListener("DOMContentLoaded", () => {
  new Vue({
    el: "#app",
    components: { IndexList, StudioList, StudioDetail, RecommendList, AreaList },
  });
});
